"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _reduxForm = require("redux-form");

var _reactRedux = require("react-redux");

var _Switcher = _interopRequireDefault(require("./Switcher"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Dates() {
  try {
    var handleOrderChange = function handleOrderChange(order) {
      dispatch((0, _reduxForm.change)('invoices-filter', 'order', order));
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var values = (0, _reactRedux.useSelector)((0, _reduxForm.getFormValues)('invoices-filter'));
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['label']
    }, /*#__PURE__*/_react["default"].createElement(_Switcher["default"], {
      "data-locator": "invoices.date",
      prefix: "\u0414\u0430\u0442\u0430",
      order: values['order'],
      onChange: handleOrderChange
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['fields']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['field']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.DatePickerField, {
      "data-locator": "invoice.filter.dateFrom",
      useTime: true,
      name: "dateFrom",
      maxDate: new Date(values['dateTo']),
      outFormat: "YYYY-MM-DD HH:mm:ss",
      displayFormat: "DD.MM.YYYY HH:mm"
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['separator']
    }, "-"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['field']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.DatePickerField, {
      "data-locator": "invoice.filter.dateTo",
      useTime: true,
      name: "dateTo",
      minDate: new Date(values['dateFrom']),
      maxDate: new Date(),
      outFormat: "YYYY-MM-DD HH:mm:ss",
      displayFormat: "DD.MM.YYYY HH:mm"
    }))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Dates;
exports["default"] = _default;